import {Injectable} from '@angular/core';

import {Observable, of} from 'rxjs';
import {tap} from 'rxjs/operators';

// import { NavigateService } from '../services/navigate/navigate.service';
import { NavigateService } from '@modweb5/sharedServices/navigateService/navigate.service';
import { DataGateService } from '@modweb5/sharedServices/dataGate/data-gate.service';


@Injectable()
export class AuthenticationGuard  {

	userWasLoginAlready = false;

	constructor(
		private _navigateService: NavigateService,
		private _dataGateService: DataGateService
	) {
	}

	setUserWasLoginAlready(value: boolean): void {
		this.userWasLoginAlready = value;
	}

	// 
	canActivate(): Observable<boolean> {
		// Zajišťuje, aby se modul nezačal spouštět, pokud uživatel nebyl přihlášen.
		if (this.userWasLoginAlready) {
			return of(true);
		} else {
			return this._dataGateService.checkUserAuthentication$().pipe(
				tap(isAuthenticated => {
					if (isAuthenticated) {
						this.userWasLoginAlready = true;
					} else {
						this._navigateService.navigate('login', '');
					}
				})
			);
		}
	}
}
